import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { updateComponent } from '../../state/actions/componentsActions'
import { connect } from 'react-redux'
import Button from '../button'
import { activate } from '../../state/api'

// import { withStyles } from '../../styles/withStyles'
// import Styles from './styles'

class AttivaButton extends Component {
  constructor(props) {
    super(props)
  }

  onClick(e) {
    const { component, dispatch } = this.props
    if (component.action !== {})
      dispatch(updateComponent(component.id, component.action))
  }

  render() {
    const { component } = this.props
     if(component.id==="ATTIVA_REVOCA_FIRMA-VISIONE" 
        && (component.value==="Attivata" || component.value==="Firmato")
       )  //Rewamp of whole digital contracts in last step (All flows)	
    {
      component.display="none"
    }
    return (
      <Button
        key={component.id}
        text={component.value}
        {...component}
        action={e => this.onClick(e)}
      />
    )
  
  }
}

AttivaButton.propTypes = {
  widget: PropTypes.object.isRequired,
  component: PropTypes.object.isRequired
  // styles: PropTypes.object.isRequired
}

const mapStateToProps = (state, ownProps) => {
  const { components } = state
  return { component: components[ownProps.component.id] }
}

export default connect(mapStateToProps)(AttivaButton)



// WEBPACK FOOTER //
// ./components/attivaButton/index.js